import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtoathnicabbooking() {



    const cardData = {




keyword: "Belgaum to Athani Cab Booking",

headingDescription: "Belgaum Taxi Service provides reliable, comfortable, and affordable Belgaum to Athani cab booking services for local travel, business visits, family trips, medical requirements, educational purposes, and daily transportation needs. Whether you need a one-way taxi or a round-trip cab from Belgaum to Athani, we offer convenient travel solutions with experienced drivers and well-maintained vehicles. Our fleet includes Swift Dzire, Sedan, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars suitable for individuals, families, corporate travelers, and groups. With easy cab booking options, doorstep pickup and drop, flexible travel timings, transparent pricing, and 24/7 customer support, we ensure a smooth and stress-free journey. Belgaum Taxi Service connects passengers between Belgaum and Athani with safe and comfortable transportation for business meetings, government work, family functions, shopping, hospital visits, and personal travel. Our professional chauffeurs, clean vehicles, punctual service, and customer-focused approach make every journey convenient and enjoyable. Whether you are traveling for short-distance work or planning connectivity to nearby Karnataka and Maharashtra destinations, our Belgaum to Athani taxi service provides dependable cab solutions according to your travel requirements.",

topPlaces: [
  {
    title: "Athani",
    description: "Athani is an important town in Belagavi district known for agriculture, trade, local markets, temples, and commercial activities. It is a frequently traveled destination from Belgaum for business and personal visits."
  },
  {
    title: "Banashankari Temple Athani",
    description: "Banashankari Temple is a popular religious attraction in Athani visited by devotees for spiritual purposes and local pilgrimage trips."
  },
  {
    title: "Gokak",
    description: "Gokak is a famous destination near Belgaum known for Gokak Falls, historical attractions, and scenic landscapes. It is a popular place for family trips and sightseeing."
  },
  {
    title: "Vijayapura",
    description: "Vijayapura (Bijapur) is a historic city famous for Gol Gumbaz, ancient monuments, Islamic architecture, and cultural heritage attractions."
  },
  {
    title: "Bagalkot",
    description: "Bagalkot is an important Karnataka city known for historical sites, business activities, and nearby attractions like Badami, Aihole, and Pattadakal."
  },
  {
    title: "Badami",
    description: "Badami is a heritage destination famous for rock-cut cave temples, sandstone cliffs, and Chalukyan architecture, attracting history lovers and tourists."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a major Maharashtra city known for Mahalaxmi Temple, traditional markets, cultural heritage, shopping, and business activities."
  },
  {
    title: "Goa",
    description: "Goa is a popular holiday destination known for beaches, resorts, churches, water activities, and sightseeing attractions. Private cabs provide comfortable travel for leisure trips."
  },
  {
    title: "Pune",
    description: "Pune is a major IT, education, and industrial hub in Maharashtra with corporate offices, technology parks, universities, and commercial centers."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital known for business districts, airports, entertainment destinations, and tourist attractions. Comfortable taxi services provide convenient interstate travel."
  }
],




"services": [
  {
    "name": "Belgaum to Athani Cab Booking",
    "description": "Book Belgaum to Athani Cab Booking service for safe, comfortable, and affordable travel between Belgaum and Athani. Get reliable chauffeur-driven cabs with Sedan, Ertiga, Innova Crysta, and SUV options for one way trips, round trips, family travel, business journeys, and local transportation with easy online booking facilities."
  },
  {
    "name": "Belgaum to Athani Cab",
    "description": "Hire Belgaum to Athani Cab for convenient intercity travel with professional drivers, clean AC vehicles, transparent pricing, and doorstep pickup services. Our cab service is suitable for personal trips, corporate travel, airport transfers, and outstation journeys with flexible travel options."
  },
  {
    "name": "Belgaum to Athani Taxi",
    "description": "Choose Belgaum to Athani Taxi service for comfortable and reliable transportation with experienced chauffeurs and well-maintained vehicles. Travel hassle-free with affordable taxi fares, quick booking assistance, and premium cab options available for different travel requirements."
  },
  {
    "name": "Belgaum to Athani Cab Service",
    "description": "Get Belgaum to Athani Cab Service for smooth and convenient travel with professional drivers, comfortable seating, and timely pickup facilities. We provide dependable taxi solutions for families, corporate travelers, tourists, and passengers looking for safe outstation transportation."
  },
  {
    "name": "Belgaum to Athani Taxi Service",
    "description": "Book Belgaum to Athani Taxi Service for economical and comfortable journeys with flexible one way and round trip options. Enjoy sanitized cars, experienced chauffeurs, affordable fares, and reliable travel support throughout your journey."
  },
  {
    "name": "Belgaum to Athani One Way Cab",
    "description": "Reserve Belgaum to Athani One Way Cab for budget-friendly single destination travel without return charges. Enjoy fixed pricing, doorstep pickup, comfortable AC vehicles, and professional drivers for a stress-free journey."
  },
  {
    "name": "Belgaum to Athani One Way Taxi",
    "description": "Choose Belgaum to Athani One Way Taxi for convenient point-to-point travel with affordable rates and reliable service. Our one way taxi packages are ideal for business trips, personal travel, and urgent transportation needs."
  },
  {
    "name": "Belgaum to Athani Cab Booking Online",
    "description": "Complete Belgaum to Athani Cab Booking Online with easy reservations, quick confirmation, multiple vehicle choices, and flexible pickup locations. Book Sedan, Ertiga, Innova Crysta, and premium cabs according to your travel requirements."
  },
  {
    "name": "Belgaum to Athani Taxi Booking",
    "description": "Book Belgaum to Athani Taxi Booking service for comfortable and affordable travel solutions. Get professional chauffeurs, clean vehicles, transparent fares, and reliable taxi availability for local and outstation journeys."
  },
  {
    "name": "Belgaum to Athani Car Rental",
    "description": "Hire Belgaum to Athani Car Rental service for flexible travel options with driver-operated vehicles. Choose from Sedan, SUV, Ertiga, and Innova Crysta cars for family trips, corporate travel, sightseeing, and long-distance journeys."
  },
  {
    "name": "Belgaum to Athani Outstation Cab",
    "description": "Book Belgaum to Athani Outstation Cab for safe and comfortable intercity travel with experienced drivers and premium vehicles. Our outstation cab services provide reliable transportation with one way, round trip, and customized travel packages."
  },
  {
    "name": "Belgaum to Athani Innova Crysta Cab",
    "description": "Travel comfortably with Belgaum to Athani Innova Crysta Cab offering spacious seating, premium interiors, large luggage capacity, and professional chauffeurs. Ideal for family trips, corporate travel, group journeys, and premium transportation."
  },
  {
    "name": "Belgaum to Athani Ertiga Cab",
    "description": "Book Belgaum to Athani Ertiga Cab for affordable 6 to 7 seater travel with comfortable interiors and reliable drivers. Perfect for families, small groups, airport transfers, and outstation travel requirements."
  },
  {
    "name": "Belgaum to Athani Sedan Cab",
    "description": "Choose Belgaum to Athani Sedan Cab for economical and comfortable travel with clean AC vehicles and skilled chauffeurs. Sedan cabs are suitable for business meetings, personal trips, and hassle-free city-to-city travel."
  },
  {
    "name": "Belgaum to Athani Round Trip Cab",
    "description": "Book Belgaum to Athani Round Trip Cab for convenient return journeys with affordable packages and flexible schedules. Enjoy comfortable travel for family visits, business work, sightseeing, and weekend trips."
  },
  {
    "name": "Belgaum to Athani Private Taxi",
    "description": "Hire Belgaum to Athani Private Taxi for personalized travel with dedicated vehicles and professional drivers. Experience safe, private, and comfortable transportation according to your preferred travel schedule."
  },
  {
    "name": "Cheap Belgaum to Athani Cab",
    "description": "Find Cheap Belgaum to Athani Cab services offering affordable fares without compromising comfort and safety. Get reliable vehicles, experienced drivers, and budget-friendly travel options for every journey."
  },
  {
    "name": "Best Belgaum to Athani Cab Service",
    "description": "Choose the Best Belgaum to Athani Cab Service with premium vehicles, trained chauffeurs, affordable pricing, and dependable customer support. Enjoy smooth transportation for personal, family, and professional travel needs."
  },
  {
    "name": "Online Belgaum to Athani Cab Booking",
    "description": "Book Online Belgaum to Athani Cab Booking service with quick reservations, easy confirmation, and flexible travel options. Get comfortable AC cabs with professional drivers for safe and convenient journeys."
  },
  {
    "name": "Belgaum to Athani Taxi Fare",
    "description": "Check Belgaum to Athani Taxi Fare and choose affordable cab packages based on your vehicle requirements. Get transparent pricing for Sedan, Ertiga, Innova Crysta, and SUV taxi options."
  },
  {
    "name": "Belgaum to Athani Car Hire",
    "description": "Hire Belgaum to Athani Car Hire service for comfortable and flexible travel with driver facilities. Our rental cars are perfect for family trips, business travel, sightseeing, and outstation transportation."
  },
  {
    "name": "Belgaum to Athani Cab Price",
    "description": "Get affordable Belgaum to Athani Cab Price with multiple vehicle choices and transparent fare options. Enjoy reliable cab services with no hidden charges and professional travel assistance."
  },
  {
    "name": "Belgaum to Athani Family Cab",
    "description": "Book Belgaum to Athani Family Cab for safe and comfortable journeys with spacious vehicles and experienced drivers. Perfect for family visits, functions, vacations, and personal travel requirements."
  },
  {
    "name": "Belgaum to Athani Corporate Taxi",
    "description": "Choose Belgaum to Athani Corporate Taxi service for business travel solutions with punctual pickup, professional chauffeurs, and comfortable vehicles. Ideal for meetings, employee travel, and corporate transportation needs."
  },
  {
    "name": "Belgaum to Athani Airport Transfer",
    "description": "Book Belgaum to Athani Airport Transfer service for timely airport pickup and drop transportation. Enjoy comfortable vehicles, experienced drivers, and hassle-free airport travel solutions."
  },
  {
    "name": "Belgaum to Athani Cab Fare",
    "description": "Get competitive Belgaum to Athani Cab Fare with reliable taxi services and multiple vehicle categories. Choose the right cab according to your budget, passenger count, and travel requirements."
  },
  {
    "name": "Belgaum to Athani Taxi Near Me",
    "description": "Find Belgaum to Athani Taxi Near Me for quick and reliable cab availability. Get doorstep pickup, professional drivers, comfortable cars, and convenient booking support for your journey."
  },
  {
    "name": "Belgaum to Athani Outstation Taxi",
    "description": "Book Belgaum to Athani Outstation Taxi for safe long-distance travel with experienced chauffeurs and well-maintained vehicles. Enjoy flexible travel plans, affordable fares, and comfortable transportation."
  },
  {
    "name": "Belgaum to Athani Travel by Cab",
    "description": "Travel from Belgaum to Athani by Cab with comfortable seating, professional drivers, and reliable service. Enjoy a smooth journey with premium vehicles suitable for families, business travelers, and personal trips."
  }
],
"tableData": [
  ["Belgaum to Athani Cab Booking", "Belgaum to Athani Cab"],
  ["Belgaum to Athani Taxi", "Belgaum to Athani Cab Service"],
  ["Belgaum to Athani Taxi Service", "Belgaum to Athani One Way Cab"],
  ["Belgaum to Athani One Way Taxi", "Belgaum to Athani Cab Booking Online"],
  ["Belgaum to Athani Taxi Booking", "Belgaum to Athani Car Rental"],
  ["Belgaum to Athani Outstation Cab", "Belgaum to Athani Innova Crysta Cab"],
  ["Belgaum to Athani Ertiga Cab", "Belgaum to Athani Sedan Cab"],
  ["Belgaum to Athani Round Trip Cab", "Belgaum to Athani Private Taxi"],
  ["Cheap Belgaum to Athani Cab", "Best Belgaum to Athani Cab Service"],
  ["Online Belgaum to Athani Cab Booking", "Belgaum to Athani Taxi Fare"],
  ["Belgaum to Athani Car Hire", "Belgaum to Athani Cab Price"],
  ["Belgaum to Athani Family Cab", "Belgaum to Athani Corporate Taxi"],
  ["Belgaum to Athani Airport Transfer", "Belgaum to Athani Cab Fare"],
  ["Belgaum to Athani Taxi Near Me", "Belgaum to Athani Outstation Taxi"],
  ["Belgaum to Athani Travel by Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Easy Belgaum to Athani Cab Booking",
    WhyChoosedescription: "Book a comfortable taxi from Belgaum to Athani with convenient travel options, experienced drivers, and well-maintained vehicles for a smooth and enjoyable journey."
  },
  {
    WhyChooseheading: "Direct Taxi Service Between Cities",
    WhyChoosedescription: "Travel without unnecessary stops with direct pickup from your preferred location in Belgaum and drop service at your destination in Athani."
  },
  {
    WhyChooseheading: "Vehicles According to Your Comfort",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs based on passenger numbers, luggage space, and travel preferences."
  },
  {
    WhyChooseheading: "Perfect for Personal & Professional Travel",
    WhyChoosedescription: "Our Belgaum to Athani taxis are suitable for family visits, business meetings, medical trips, local work, and other transportation needs."
  },
  {
    WhyChooseheading: "Experienced Drivers on the Route",
    WhyChoosedescription: "Professional chauffeurs provide safe driving, timely pickup, and a comfortable travel experience with knowledge of the Belgaum to Athani route."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Select a one-way cab for direct travel or plan a return journey with flexible timings according to your schedule."
  },
  {
    WhyChooseheading: "Clean & Comfortable Cab Fleet",
    WhyChoosedescription: "Enjoy your journey in hygienic vehicles with comfortable seating and proper maintenance for a pleasant travel experience."
  },
  {
    WhyChooseheading: "Quick Booking Assistance",
    WhyChoosedescription: "Get support for vehicle selection, fare details, and cab availability to complete your Belgaum to Athani cab booking easily."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Athani Cab Booking?",
    answer: "Yes, we provide Belgaum to Athani taxi booking services with comfortable vehicles and professional drivers."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Athani?",
    answer: "Yes, one-way taxi service is available for passengers who need direct travel between Belgaum and Athani."
  },
  {
    question: "Which cars are available for Belgaum to Athani travel?",
    answer: "You can choose Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs based on your travel requirements."
  },
  {
    question: "Is Belgaum to Athani cab suitable for family trips?",
    answer: "Yes, spacious and comfortable vehicles are available for families and groups travelling between Belgaum and Athani."
  },
  {
    question: "Can I book a return taxi from Athani to Belgaum?",
    answer: "Yes, return journey cabs are available with flexible travel schedules according to your convenience."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop facilities are available from Belgaum Airport, Railway Station, hotels, homes, and other preferred locations."
  },
  {
    question: "Can I hire a private cab from Belgaum to Athani?",
    answer: "Yes, private taxi options are available with dedicated vehicles and drivers for a comfortable journey."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable toll, parking, and additional travel charges depend on the selected package and are explained during booking."
  },
  {
    question: "Is Belgaum to Athani taxi service available anytime?",
    answer: "Yes, taxi booking assistance is available for planned trips and urgent travel requirements."
  },
  {
    question: "How can I complete Belgaum to Athani Cab Booking?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ramesh Patil",
    feedback: "The Belgaum to Athani cab booking process was simple and quick. The driver arrived on time, and the journey was comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Desai",
    feedback: "We booked a cab for a family visit to Athani and had a smooth experience. The vehicle was clean, and the service was professional.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Athani Cab Booking",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-athani-cab-booking.webp",
  "description":
    "Book Belgaum to Athani Cab Booking with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Athani with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business travel, family trips, local visits, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-athani-cab-booking"
  }
};








    return (
        <div>


<Helmet>
  <title>Belgaum to Athani Cab Booking | One Way Taxi | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Athani Cab Booking with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Athani with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Athani Cab Booking, Belgaum to Athani Cab, Belgaum to Athani Taxi, Belgaum to Athani Cab Service, Belgaum to Athani Taxi Service, Belgaum to Athani One Way Cab, Belgaum to Athani One Way Taxi, Belgaum to Athani Taxi Booking, Belgaum to Athani Car Rental, Belgaum to Athani Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/48.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtoathnicabbooking ;